import React from "react";

const bulletStyle = `
  relative pl-4 mb-6
  text-black font-uber text-base font-normal leading-normal
  before:content-['•'] before:absolute before:left-0 before:text-lg before:font-bold
`;

export default function AnalyticsConversion() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="mx-auto max-w-6xl py-16 px-4 sm:px-6">
        
        <div className="flex flex-col xl-custom:flex-row gap-8 xl-custom:items-start items-center mb-4">
          
          <div className="w-full xl-custom:w-[60%] order-1 xl-custom:order-1">
            <h2 
              className="
                w-full text-black mb-4
                font-uber text-[28px] font-bold leading-[36px] text-current
                sm:text-[32px] sm:leading-[40px]
                xl-custom:text-[36px] xl-custom:leading-[44px]
                transition duration-200 ease-in-out
              "
            >
              Driving Digital Conversions
            </h2>
            
            <p className="mb-8 text-black font-uber text-base font-normal leading-normal
">
              Microsites Deliver Engagement and Actionable Results
            </p>
            
            <ul className="flex flex-wrap gap-x-6">
              <li className={`w-full xl-custom:w-[49%] ${bulletStyle}`}>
                The campaign microsites recorded thousands of page views, driving user engagement through interactive experiences.
              </li>
              <li className={`w-full xl-custom:w-[49%] ${bulletStyle}`}>
                Session durations of up to 188 seconds demonstrated an effective blend of engagement and content retention.
              </li>
            </ul>
          </div>
          
          <div className="w-full xl-custom:w-[40%] order-2 xl-custom:order-2">
            <div className="w-full rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="/uploads/Analytics/14.webp"
                className="w-full h-full object-cover rounded-2xl" 
                alt="Conclusion visual placeholder" 
              />
            </div>
          </div>
        </div>
        
        <div className="w-full mt-4">
          <p className={`${bulletStyle}`}>
            Click-through rates on promotional offers and in-game actions showed a consistent uplift in user participation, reinforcing conversion effectiveness.
          </p>
        </div>
        
        <p className="mt-8 text-black font-uber text-base font-normal leading-normal">By leveraging interactive and gamified elements, microsites ensure sustained engagement, maximizing digital impact and brand recall</p>
      </div>
    </section>
  );
}